import { SmartCheckSessionDeletionAction } from '../actions/smartCheckSessionDeletionActions'

export enum SmartCheckSessionsStatus {
	IDLE_STATUS = 'idle',
	LOADING_STATUS = 'loading',
	FAILURE_STATUS = 'failure',
}

export interface SmartCheckSessionState {
	status: SmartCheckSessionsStatus
	applicantId: string | null
}

export const INITIAL_STATE: SmartCheckSessionState = {
	status: SmartCheckSessionsStatus.IDLE_STATUS,
	applicantId: null,
}

const idleSmartCheckSessionReducer = (
	state: SmartCheckSessionState,
	action: SmartCheckSessionDeletionAction,
): SmartCheckSessionState => {
	switch (action.type) {
		case 'smartCheckSession/delete':
			return {
				...state,
				status: SmartCheckSessionsStatus.LOADING_STATUS,
			}
		default:
			return state
	}
}

const loadingSmartCheckSessionReducer = (
	state: SmartCheckSessionState,
	action: SmartCheckSessionDeletionAction,
): SmartCheckSessionState => {
	switch (action.type) {
		case 'smartCheckSession/deleteSuccess':
			return {
				...state,
				status: SmartCheckSessionsStatus.IDLE_STATUS,
			}
		case 'smartCheckSession/deleteFailure':
			return {
				...state,
				status: SmartCheckSessionsStatus.FAILURE_STATUS,
			}
		default:
			return state
	}
}

const failureSmartCheckSessionReducer = (
	state: SmartCheckSessionState,
	action: SmartCheckSessionDeletionAction,
): SmartCheckSessionState => {
	switch (action.type) {
		case 'smartCheckSession/delete':
			return {
				...state,
				status: SmartCheckSessionsStatus.LOADING_STATUS,
			}
		default:
			return state
	}
}

export default function reduce(
	state: SmartCheckSessionState = INITIAL_STATE,
	action: SmartCheckSessionDeletionAction,
): SmartCheckSessionState {
	switch (state.status) {
		case SmartCheckSessionsStatus.IDLE_STATUS:
			return idleSmartCheckSessionReducer(state, action)
		case SmartCheckSessionsStatus.LOADING_STATUS:
			return loadingSmartCheckSessionReducer(state, action)
		case SmartCheckSessionsStatus.FAILURE_STATUS:
			return failureSmartCheckSessionReducer(state, action)
		default:
			return state
	}
}
